import React, { useCallback } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { UniversalCreateButtonLazy as UniversalCreateButton } from '@atlassian/universal-create/button/lazy';
import type { MenuItem } from '@atlassian/universal-create/types';

import { useIntl } from '@atlassian/jira-intl';

import { NavigationCreateIssueButtonWrapperNudgeAsync } from '@atlassian/jira-software-onboarding-nudges--next/src/ui/navigation-create-issue/async.tsx';
import { TopLevelErrorBoundary } from '@atlassian/jira-navigation-apps-topnav4-common/src/ui/error-boundary/index.tsx';
import { Ati } from '@atlassian/ari/ati';
import messages from './messages.tsx';
import {
	GLOBAL_CREATE_BUTTON_NAV4,
	GLOBAL_CREATE_BUTTON_WRAPPER,
	UNIVERSAL_CREATE_BUTTON_ID,
} from './constants.tsx';
import {
	useCreateIssueItem,
	useUniversalCreateItems,
} from './hooks/use-universal-create-items.tsx';

function ServerSideCreate() {
	const { formatMessage } = useIntl();

	const dummyItem: MenuItem = {
		ati: Ati.parse('ati:cloud:issue:create'),
		children: formatMessage(messages.createIssue),
	};

	return (
		<Box testId={`${GLOBAL_CREATE_BUTTON_WRAPPER}-server-side`}>
			<UniversalCreateButton
				product="jira"
				items={[dummyItem]}
				testId={GLOBAL_CREATE_BUTTON_NAV4}
				primaryActionItem={dummyItem}
			>
				{formatMessage(messages.create)}
			</UniversalCreateButton>
		</Box>
	);
}

function ClientSideCreate() {
	const { formatMessage } = useIntl();

	const createIssueItem = useCreateIssueItem();

	const menuSection = useUniversalCreateItems();

	menuSection.items.push(createIssueItem); // ensure the create issue is always in the menu

	const onDropdownMenuOpen = useCallback(() => {
		// TODO: https://hello.jira.atlassian.cloud/browse/NAVX-2432
	}, []);

	return (
		<Box testId={`${GLOBAL_CREATE_BUTTON_WRAPPER}-client-side`}>
			<NavigationCreateIssueButtonWrapperNudgeAsync>
				<UniversalCreateButton
					product="jira"
					onClick={onDropdownMenuOpen}
					items={[menuSection]}
					testId={GLOBAL_CREATE_BUTTON_NAV4}
					primaryActionItem={createIssueItem}
				>
					{formatMessage(messages.create)}
				</UniversalCreateButton>
			</NavigationCreateIssueButtonWrapperNudgeAsync>
		</Box>
	);
}

export function UniversalCreate() {
	return (
		<TopLevelErrorBoundary id={UNIVERSAL_CREATE_BUTTON_ID}>
			{__SERVER__ ? <ServerSideCreate /> : <ClientSideCreate />}
		</TopLevelErrorBoundary>
	);
}
